import {
  ENROLL_CUSTOMER,
  ENROLL_CUSTOMER_FULFILLED,
  ENROLL_CUSTOMER_REJECTED,
  ENROLL_CUSTOMER_STATE_RESET,
  ADD_CUSTOMER,
  ADD_CUSTOMER_TO_SALE,
  ADD_CUSTOMER_TO_SALE_FULFILLED,
  ADD_CUSTOMER_TO_SALE_REJECTED,
  GET_CUSTOMER,
  GET_CUSTOMER_FULFILLED,
  GET_CUSTOMER_REJECTED,
  GET_CUSTOMER_STATE_RESET,
  RESET_CUSTOMER,
  REMOVE_CUSTOMER_FROM_SALE,
  REMOVE_CUSTOMER_FROM_SALE_FULFILLED,
  REMOVE_CUSTOMER_FROM_SALE_REJECTED,
  SET_POINT_BALANCE,
} from './';

export function enrollCustomer(phoneNumber) {
  return {
    type: ENROLL_CUSTOMER,
    payload: { phoneNumber },
  };
}

export function enrollCustomerFulfilled() {
  return {
    type: ENROLL_CUSTOMER_FULFILLED,
  };
}

export function enrollCustomerRejected(error) {
  return {
    type: ENROLL_CUSTOMER_REJECTED,
    payload: { error },
  };
}

export function enrollCustomerStateReset() {
  return {
    type: ENROLL_CUSTOMER_STATE_RESET,
  };
}

export function addCustomer(customer, context) {
  return {
    type: ADD_CUSTOMER,
    payload: { customer, context },
  };
}

export function addCustomerToSale(customer) {
  return {
    type: ADD_CUSTOMER_TO_SALE,
    payload: { customer },
  };
}

export function addCustomerToSaleFulfilled() {
  return {
    type: ADD_CUSTOMER_TO_SALE_FULFILLED,
  };
}

export function addCustomerToSaleRejected(error) {
  return {
    type: ADD_CUSTOMER_TO_SALE_REJECTED,
    payload: { error },
  };
}

export function resetCustomer() {
  return {
    type: RESET_CUSTOMER,
  };
}

export function removeCustomerFromSale() {
  return {
    type: REMOVE_CUSTOMER_FROM_SALE,
  };
}

export function removeCustomerFromSaleFulfilled() {
  return {
    type: REMOVE_CUSTOMER_FROM_SALE_FULFILLED,
  };
}

export function setPointBalance(pointBalance) {
  return {
    type: SET_POINT_BALANCE,
    payload: { pointBalance },
  };
}

export function removeCustomerFromSaleRejected(error) {
  return {
    type: REMOVE_CUSTOMER_FROM_SALE_REJECTED,
    payload: { error },
  };
}

export function getCustomer(context, referenceId) {
  return {
    type: GET_CUSTOMER,
    payload: { referenceId, context },
  };
}

export function getCustomerFulfilled() {
  return {
    type: GET_CUSTOMER_FULFILLED,
  };
}

export function getCustomerRejected(context, error) {
  return {
    type: GET_CUSTOMER_REJECTED,
    payload: { context, error },
  };
}

export function getCustomerStateReset() {
  return {
    type: GET_CUSTOMER_STATE_RESET,
  };
}
